export default {"src":"/_next/static/media/react.4f7e5458.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};